import classNames from 'classnames'
import React, { ReactNode } from 'react'

import { Button, ButtonProps } from '../button/button.js'
import { CheckCircleLargeIcon, WarningCircleIcon } from '../icon/icon.js'
import { Spinner } from '../spinner/spinner.js'

export interface PaymentCardProps {
    button: ButtonProps
    content: ReactNode
    price: string
    title: string
    className?: string
    isLoading?: boolean
    type?: 'success' | 'error'
}

export const PaymentCard = (props: PaymentCardProps): JSX.Element => {
    const { button, content, isLoading, price, title, type = 'success' } = props

    const isError = type === 'error'

    const className: string = classNames(
        'payment-card',
        {
            [`payment-card--type-${type}`]: type,
            'is-loading': isLoading,
        },
        props.className,
    )

    return (
        <div className={className}>
            {isLoading ? (
                <Spinner height={212} size="medium" />
            ) : (
                <>
                    {isError ? (
                        <WarningCircleIcon className="payment-card__icon" />
                    ) : (
                        <CheckCircleLargeIcon className="payment-card__icon" />
                    )}
                    <h1 className="payment-card__title h1">{title}</h1>
                    <p className="payment-card__price text-price">{price}</p>
                    <p className="payment-card__content">{content}</p>
                    <Button {...button} className="payment-card__button" isBlock={true} variant="secondary" />
                </>
            )}
        </div>
    )
}
